<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <VAModal ref="md">
          <template v-slot:title>Kênh nguồn data</template>
          <template v-slot:body>
            <form>
              <div class="form-group row">
                <label for="inputStatusName" class="col-sm-3 col-form-label">Tên trạng thái</label>
                <div class="col-sm-9">
                  <input class="form-control" id="inputStatusName" v-model="newItemData.name">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputStatusName" class="col-sm-3 col-form-label">Nguồn data</label>
                <div class="col-sm-9">
                  <input class="form-control" disabled :value="dataSource.name">
                </div>
              </div>
              <div class="form-group row">
                <label for="inputStatusName" class="col-sm-3 col-form-label">Đặt mặc định</label>
                <div class="col-sm-9">
                  <div class="form-check">
                    <input v-model="newItemData.choose_by_default" type="checkbox" class="form-check-input" id="inputChooseByDefault" style="margin-top: 6px; margin-left: -18px" />
                    <label class="form-check-label" for="inputChooseByDefault"> </label>
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:save-button>
            <button type="button" class="btn btn-sm btn-pink" @click="add">
              <span aria-hidden="true" class="glyphicon glyphicon-ok"></span> Lưu
            </button>
          </template>
        </VAModal>
        <va-box theme="box-primary" title="Kênh Nguồn Data">
          <div slot="content" class="container-fuild">
            <div class="row">
              <div class="col">
                <b-button class="btn btn-sm btn-warning" @click="$router.back()">
                  <span class="glyphicon glyphicon-backward" aria-hidden="true"></span> Quay lại
                </b-button>
                <b-button class="btn btn-sm btn-danger" @click="openModalAdd()">
                  <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Thêm mới
                </b-button>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                         show-empty>
                  <template #table-busy>
                    <div class="text-center my-2 mt-5 mb-5">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Đang tải...</strong>
                    </div>
                  </template>

                  <template #empty="scope">
                    <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div>
                      <b>{{ data.item.name }}</b>
                    </div>
                  </template>
                  <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at | format_date }}
                  </template>
                  <template v-slot:cell(choose_by_default)="data">
                    <div>
                      <i v-if="data.item.choose_by_default" class="glyphicon glyphicon-ok color-blue"/>
                      <i v-else class="glyphicon glyphicon-remove color-pink"/>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="edit(data.item)">
                      <i class="fa fa-edit"/>
                    </b-button>
                    <b-button variant="danger" v-b-tooltip.hover title="Xoá"
                              @click="remove(data.item)">
                      <i class="fa fa-trash"/>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import DataChannelApi from '../../api/dataChannel'
import DataSourceApi from '../../api/dataSource'
import Utils from '../../common/utils'
import VAModal from '../../components/VAModal'
import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'DataChannel',
  components: {
    VAModal,
    Multiselect,
    'va-box': VABox
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  data () {
    return {
      filterData: {
        name: null,
      },
      items: [],
      fields: [
        {
          key: 'name',
          label: 'Tên'
        },
        {
          key: 'choose_by_default',
          label: 'Mặc định chọn'
        },
        {
          key: 'data_source',
          label: 'Nguồn data'
        },
        {
          key: 'created_at',
          label: 'Ngày tạo'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      newItemData: {
        id: null,
        name: '',
        company_id: '',
        data_source_id: 0,
        choose_by_default: false,
      },
      dataSource: {
        name: '',
      },
      isLoading: false,
    }
  },
  mounted () {
    const company = Utils.getCompanyByUserInfo(this.userInfo)
    this.newItemData.company_id = company.id
    this.newItemData.data_source_id = this.$route.params.id
    DataSourceApi.get(this.$route.params.id).then(res => {
      this.items = res.data.data.data_channels
      this.dataSource = res.data.data
    })
  },
  methods: {
    add () {
      if (!this.newItemData.id && this.newItemData.name) {
        this.loading = true
        DataChannelApi.create(this.newItemData)
          .then((res) => {
            Utils.successToast(this.$bvToast)
            this.items.push(res.data.data)
          })
          .catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
          .finally(() => {
            this.loading = false
            this.$refs.md.hide()
            this.reset()
          })
      }

      if (this.newItemData.id) {
        this.loading = true
        DataChannelApi.update(this.newItemData)
          .then((res) => {
            Utils.successToast(this.$bvToast)
            const copyId = this.newItemData.id
            const i = this.items.findIndex(v => v.id === copyId)
            let copyItem = [...this.items]
            copyItem[i] = res.data.data
            this.items = copyItem
          })
          .catch(err => {
            Utils.handleError(this.$bvToast, err)
          })
          .finally(() => {
            this.loading = false
            this.$refs.md.hide()
            this.reset()
          })
      }
    },
    openModalAdd () {
      this.reset()
      this.$refs.md.show()
    },
    reset () {
      this.newItemData.id = ''
      this.newItemData.name = ''
      this.newItemData.choose_by_default = false
    },
    edit (item) {
      this.newItemData.id = item.id
      this.newItemData.name = item.name
      this.newItemData.choose_by_default = item.choose_by_default
      this.$refs.md.show()
    },
    remove (item) {
      this.$bvModal.msgBoxConfirm('Xóa "' + item.name + '". Bạn có chắc không?', {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
        footerClass: 'p-2'
      }).then(res => {
        if (res) {
          this.loading = true
          DataChannelApi.remove(item.id)
            .then(res => {
              const i = this.items.findIndex(e => e.id === item.id)
              const cp = [...this.items]
              cp.splice(i, 1)
              this.items = cp
              Utils.successToast(this.$bvToast, 'Xoá dữ liệu', 'Đã xoá thành công 1 bản ghi')
            })
            .catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/DataChannel.vue